import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: true
})
export class AutofocusDirective implements OnInit {
    private _autofocus: boolean = false;

    @Input() set autofocus(condition: boolean) {
        this._autofocus = condition != false;
    }

    constructor(private el: ElementRef) { }

    ngOnInit(): void {
        if (this._autofocus) this.el.nativeElement.focus();
        //For SSR (server side rendering) this is not safe. Use: https://github.com/angular/angular/issues/15008#issuecomment-285141070)
    }
}